<template>
  <div>
    <modal
      :name="name"
      :adaptive="true"
      height="auto"
      class="u-text-align-center"
      @closed="hide">
      <div class="dialog-header">
        {{ isBankMode ? 'ご利用の銀行の選択' : '支店の選択' }}
      </div>
      <div class="dialog-body">
        <template v-if="selectCharactors">
          {{ isBankMode ? '銀行名' : '支店名' }}の先頭文字を選択してください。
          <div class="dialog-body__buttons">
            <div
              v-for="(chars, cindex) in characters"
              :key="cindex">
              <button
                v-for="(char, cindex2) in chars"
                :key="cindex2"
                class="char-button"
                :disabled="!buttonEnabled(char)"
                @click.prevent="fetchItems(char)">
                {{ char.length === 0 ? '&nbsp;' : char }}
              </button>
            </div>
          </div>
        </template>
        <template v-else>
          <div style="text-align: right">
            <button
              class="return-button"
              @click.prevent="selectCharactors=true">
              戻る
            </button>
          </div>
          <div class="select-area">
            <div
              v-for="bank in banks"
              :key="bank.code">
              <button
                class="bank-button"
                @click.prevent="onItemSelected(bank)">
                {{ isBankMode ? bank.name : bank.branch_name }}
              </button>
            </div>
          </div>
        </template>
      </div>
      <div class="dialog-footer">
        <button
          class="c-btn"
          @click.prevent="onCancelClicked">
          キャンセル
        </button>
      </div>
    </modal>
  </div>
</template>
<script>

export default {
  name: 'BankSelectDialog',
  props: {
    name: {
      type: String,
      required: true,
    },
    isShown: {
      type: Boolean,
      default: false,
    },
    isBankMode: {
      type: Boolean,
      default: true,
    },
    bankCode: {
      type: String,
      default: null,
    },
    characters: {
      type: Array,
      default: () => ([
        ['ワ'],
        ['ラ', 'リ', 'ル', 'レ', 'ロ'],
        ['ヤ', 'ユ', 'ヨ'],
        ['マ', 'ミ', 'ム', 'メ', 'モ'],
        ['ハ', 'ヒ', 'フ', 'ヘ', 'ホ'],
        ['ナ', 'ニ', 'ヌ', 'ネ', 'ノ'],
        ['タ', 'チ', 'ツ', 'テ', 'ト'],
        ['サ', 'シ', 'ス', 'セ', 'ソ'],
        ['カ', 'キ', 'ク', 'ケ', 'コ'],
        ['ア', 'イ', 'ウ', 'エ', 'オ'],
      ]),
    },
  },
  data() {
    return {
      selectCharactors: true,
      banks: [],
      branchPrefixes: [],
      prefixes: [],
    }
  },
  watch: {
    isShown() {
      this.banks = []
      this.selectCharactors = true
      if (this.isShown) {
        if (this.isBankMode) {
          this.fetchBankPrefixes()
        } else {
          this.fetchBankBranchPrefixes()
        }
        this.show()
      } else {
        this.hide()
      }
    },
  },
  methods: {
    async fetchItems(char) {
      this.banks = []
      this.selectCharactors = false
      try {
        const { data } = await window.axios.get(
          this.isBankMode
            ? `/api/client/banks?prefix=${char}`
            : `/api/client/banks/${this.bankCode}/branches?prefix=${char}`,
        )
        this.banks = data
      } catch ({ response }) {
        this.selectCharactors = true
      }
    },
    async fetchBankPrefixes() {
      const { data } = await window.axios.get('/api/client/banks/prefixes')
      this.prefixes = data
    },
    async fetchBankBranchPrefixes() {
      const { data } = await window.axios.get(`/api/client/banks/${this.bankCode}/branches/prefixes`)
      this.prefixes = data
    },
    buttonEnabled(prefix) {
      if (!prefix || prefix.length === 0) {
        return false
      }
      return this.prefixes.filter(p => p === prefix).length > 0
    },
    onItemSelected(item) {
      this.$emit(
        'select',
        this.isBankMode
          ? { code: item.code, name: item.name }
          : { code: item.branch_code, name: item.branch_name },
      )
      this.$emit('closed')
    },
    show() {
      this.$modal.show(this.name)
    },
    hide() {
      this.$modal.hide(this.name)
      this.$emit('closed')
    },
    onCancelClicked() {
      this.banks = []
      this.selectCharactors = true
      this.$emit('cancel-clicked')
    },
  },
}
</script>

<style scoped>
.dialog-header {
  text-align: center;
  font-weight: bold;
  margin-top: 12px;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
}

.dialog-body {
  text-align: center;
  vertical-align: middle;
  height: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.dialog-body__buttons{
  display: flex;
  justify-content: center;
  margin: 0 auto;
}
.dialog-body__buttons > div{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.dialog-footer {
  text-align: center;
}

@media screen and (min-width: 896px) {
  .dialog-footer {
    margin-bottom: 20px;
  }
}
.select-area {
  height: 500px;
  overflow: scroll;
}
.char-button {
  width: 44px;
  height: 44px;
  margin: 5px 5px;
  cursor: pointer;
}
.bank-button {
  width: 80%;
  height: 44px;
  margin: 5px 5px;
  cursor: pointer;
}
.return-button {
  width: 100px;
  height: 44px;
  margin: 5px 5px;
  cursor: pointer;
}
@media screen and (max-width: 896px) {
  .dialog-body {
    margin-top: 0;
  }
  .dialog-body__buttons{
    margin-top: 10px;
    flex-direction: column-reverse;
    width:90%;
  }
  .dialog-body__buttons > div{
    flex-direction: row;
    justify-content: space-between;
  }
  .char-button {
    width: 60px;
    height: 36px;
    margin: 2px 5px;
  }
}
</style>
